<template>

  <template v-if="equipmentIsSpecification">
    <HeadingBlack
      :HeadingTextBlack="$t('equipmentList')"
    ></HeadingBlack>
    <ConfigurationTableMobile
      v-if="screen"
    ></ConfigurationTableMobile>
    <ConfigurationTable
      v-if="!screen"
    ></ConfigurationTable>
  </template>
  
  <p
    class="configuration__description"
    v-else-if="description && description.length > 3"
    v-html="changeText"
  ></p>

  <template v-else-if="!equipmentIsSpecification">
    <HeadingBlack
      :HeadingTextBlack="$t('equipmentList')"
    ></HeadingBlack>
    <ConfigurationTableMobile
      v-if="screen"
    ></ConfigurationTableMobile>
    <ConfigurationTable
      v-if="!screen"
    ></ConfigurationTable>
  </template>

  <div class="sliderCarBlock__container">
    <SliderCarBlockConfiguration></SliderCarBlockConfiguration>
  </div>
</template>

<script>
import HeadingBlack from "../Header/HeadingBlack.vue";
import ConfigurationTable from "../Configuration/ConfigurationTable.vue";
import SliderCarBlockConfiguration from "../Slider/SliderCarBlockConfiguration.vue";
import ShowMore from "../YourFiles/ShowMore.vue";
import ConfigurationTableMobile from "./ConfigurationTableMobile.vue"; 
import { useStore } from "../../store";

export default {
  components: {
    HeadingBlack,
    ConfigurationTable,
    SliderCarBlockConfiguration,
    ShowMore,
    ConfigurationTableMobile,
  },
  props: {
    screen: Boolean,
  },
  computed: {
    mainOffer() {
      return useStore().getMainOffer;
    },
    mainAdditionalFile() {
      return useStore().mainAdditionalFile;
    },
    changeText() {
      if (this.description) {
        const changedHTML = this.description.replace(/\n/g, "<br>");
        return changedHTML;
      }
      return "";
    },
  },
  data() {
    return {
      equipmentData: "",
      description: "",
      equipmentIsSpecification: 0,
    };
  },
  methods: {
    getData() {
      if (useStore().mainOffer[0]) {
        this.description = useStore().mainOffer[0].description || "";
        this.equipmentIsSpecification = !!useStore().mainOffer[0].equipmentIsSpecification || false;
        const equipmentJson = useStore().mainOffer[0].equipment;

        if (equipmentJson) {
          try {
            const data = JSON.parse(equipmentJson);
            this.equipmentData = JSON.parse(data);
          } catch (e) {
            this.equipmentData = []; 
            console.error("Błąd parsowania danych wyposażenia:", e);
          }
        } else {
          this.equipmentData = [];
        }
      }
    },
  },
  mounted() {
    this.getData();
    // setTimeout(() => {
    //   // console.log(this.mainAdditionalFile[0]); // Zostawiam do ewentualnego debugowania
    // }, 1000);
  },
  watch: {
    mainOffer: {
      handler(newValue) {
        if (newValue && newValue[0]) {
          this.getData();
        }
      },
      deep: true,
    }
  },
};
</script>